function t(e, o) {
  return {
    component: e,
    page: o,
    product: "commerce-myshop-webcomponents"
  };
}
export {
  t as default
};
//# sourceMappingURL=logObject.js.map
